import React, { useEffect } from 'react'
import Login from './login'
import Browse from './browse'
 
import { RouterProvider, useNavigate } from 'react-router-dom';

import { createBrowserRouter } from 'react-router-dom'
 
const Body = () => {
 

    const approuter=createBrowserRouter(
        [ 
          {
path:"/",
element:<Login/>
          },
            {

                path:"/login",
                element:<Login/>     },
                {
                path:"/browse",
                element:<Browse/>     },

        ]
    )



  return (
    <div>
      <RouterProvider router={approuter}/>
    </div>
  )
}

export default Body